import { type RefObject, useEffect } from "react";

export function useAutoFocus(ref: RefObject<HTMLElement | null>, enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    ref.current?.focus();
  }, [enabled, ref]);
}
